// src/components/dashboard/ChartLegend.jsx
import React from 'react';
import { formatSize } from '../../utils/storage.utils';
import '../../styles/components/chartLegend.css';

export const FilesChartLegend = ({ filesBucket, maxSize, usedPercentage }) => {
  return (
    <div className="storage-legend w-100">
      <div className="legend-row">
        <div className="legend-item d-flex align-items-center">
          <span className="legend-dot" style={{ backgroundColor: '#00CC5C' }}></span>
          <span className="legend-label">Used</span>
          <span className="legend-percentage">{usedPercentage}%</span>
        </div>
        <div className="legend-size">{formatSize(filesBucket.size)}</div>
      </div>
      
      <div className="legend-row">
        <div className="legend-item d-flex align-items-center">
          <span className="legend-dot" style={{ backgroundColor: '#e9ecef' }}></span>
          <span className="legend-label">Available</span>
          <span className="legend-percentage">{100 - usedPercentage}%</span>
        </div>
        <div className="legend-size">{formatSize(maxSize - filesBucket.size)}</div>
      </div>
    </div>
  );
};

export const DistributionChartLegend = ({ buckets, percentages }) => {
  // Map color to each category 
  const categoryColors = {
    files: '#00CC5C',      // Green
    passwords: '#6f42c1',  // Purple
    banking: '#fd7e14',    // Orange
    blockchain: '#17a2b8'  // Light blue
  };

  // Create array of categories to make it easier to map over
  const categories = [
    { name: 'Files', key: 'files' },
    { name: 'Passwords', key: 'passwords' },
    { name: 'Banking', key: 'banking' },
    { name: 'Blockchain', key: 'blockchain' }
  ];

  return (
    <div className="storage-legend w-100">
      {categories.map(category => (
        <div key={category.key} className="legend-row">
          <div className="legend-item d-flex align-items-center">
            <span 
              className="legend-dot" 
              style={{ backgroundColor: categoryColors[category.key] }}
            ></span>
            <span className="legend-label">{category.name}</span>
            <span className="legend-percentage">{percentages[category.key]}%</span>
          </div>
          <div className="legend-size">{formatSize(buckets[category.key].size)}</div>
        </div>
      ))}
    </div>
  );
};